module.exports = __webpack_public_path__ + "static/img/btn-animate-stop.93b4e666.png";